import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '@/components/DropdownMenu';
import { DownloadIcon, EditFilledIcon, EllipsisIcon, SubFolderIcon, TrashIcon } from '@/components/Icons';
import { useSubscriptionStore } from '@/state/subsription-store';
import { cn } from '@/utils';
import React from 'react';

const EllipseDropDown = ({
  isHiddenEllipseIcon,
  onClickRename,
  onClickDelete,
  onClickCreateSubfolder,
  onDownloadFolder,
  ifShowSubFolder,
}: {
  isHiddenEllipseIcon: boolean;
  onClickRename: () => void;
  onClickDelete: () => void;
  onClickCreateSubfolder: () => void;
  onDownloadFolder: () => void;
  ifShowSubFolder?: boolean;
}) => {
  const { permission } = useSubscriptionStore();
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger className="outline-none">
          <EllipsisIcon
            fillColor="currentColor"
            className={cn('  right-[30px] text-jen-mid-grey group-hover/folder:block block lg:hidden', {
              '!hidden': isHiddenEllipseIcon,
            })}
          />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-[189px] bg-white  text-black text-[14px] " onClick={(e) => e.stopPropagation()}>
          <DropdownMenuItem className="cursor-pointer" onClick={onClickRename}>
            <EditFilledIcon className="mr-[4px]" fillColor="currentColor" /> Rename Folder
          </DropdownMenuItem>
          <DropdownMenuItem className="cursor-pointer" onClick={onDownloadFolder} disabled={permission.bulkDownloads === null}>
            <DownloadIcon className="mr-[4px]" fillColor="currentColor" /> Download
          </DropdownMenuItem>
          {!ifShowSubFolder && (
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                onClickCreateSubfolder();
              }}
            >
              <SubFolderIcon className="mr-[4px]" fillColor="currentColor" /> Create Subfolder
            </DropdownMenuItem>
          )}
          <DropdownMenuItem className="cursor-pointer text-jen-negative-sentiment" onClick={onClickDelete}>
            <TrashIcon className="mr-[4px]" fillColor="currentColor" /> Archive folder
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {/* <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div>
            <EllipsisIcon
              fillColor="currentColor"
              className={cn(
                '  right-[30px] text-jen-mid-grey group-hover/folder:block block lg:hidden',
                {
                  '!hidden': isHiddenEllipseIcon,
                },
              )}
            />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          side="bottom"
          className="w-[189px] bg-white  text-black text-[14px] "
          onClick={(e) => e.stopPropagation()}
        >
          <DropdownMenuRadioGroup value={'1'} onValueChange={() => { }}>
            <DropdownMenuRadioItem
              alwaysShowDot
              key={1}
              value={'1'}
              onClick={onClickRename}
            >
              Rename Folder
            </DropdownMenuRadioItem>
            <div className="border-t border-jen-lightest-grey-100 w-full"></div>
            {!ifShowSubFolder && (
              <DropdownMenuRadioItem
                alwaysShowDot
                key={2}
                value={'2'}
                onClick={(e) => {
                  e.stopPropagation();
                  onClickCreateSubfolder();
                }}
              >
                Create Subfolder
              </DropdownMenuRadioItem>
            )}
           
            <div className="border-t border-jen-lightest-grey-100 w-full"></div>

            <DropdownMenuRadioItem
              alwaysShowDot
              key={4}
              value={'4'}
              onClick={onClickDelete}
            >
              <span className="text-jen-red">Delete Folder</span>
            </DropdownMenuRadioItem>
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu> */}
    </>
  );
};

export default EllipseDropDown;
